import React from 'react';

interface CustomLabelProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

const CustomLabel: React.FC<CustomLabelProps> = ({ label, children, className }) => (
  <div className={className}>
    <div style={{ marginBottom: '.4rem' }}>
      <b>{label}</b>
    </div>
    {children}
  </div>
);

export default CustomLabel;
